import React from "react";
import ErrorBoundary from "./ErrorBoundary";

const GoogleMap = ({ location }) => {
  return (
    <ErrorBoundary>
      <iframe
        title="Google Map"
        width="100%"
        height="450"
        frameBorder="0"
        src={`https://maps.google.com/maps?q=${location}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
        allowFullScreen
      />
    </ErrorBoundary>
  );
};

export default GoogleMap;
